// a little function to help us with reordering the result
const reorder = (
  list,
  startIndex,
  endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export default reorder;

function getStageByName(name, source) {
  for (let i = source.length; i--;) {
    if (source[i].label === name) {
      return source[i].items;
    }
  }
  return [];
}

function findById(id, source) {
  for (let i = source.length; i--;) {
    if (parseInt(source[i].id) === parseInt(id)) {
      return source[i];
    }
  }
  return [];
}

export const reorderQuoteMap = ({
  quoteMap,
  source,
  destination,
  currentId,
}) => {
  let current = [];
  let next = [];
  let target = {};
  if (quoteMap) {
    if (typeof quoteMap === 'object' && quoteMap.length && quoteMap.length > 0) {
      current = getStageByName(source.droppableId, quoteMap);
      target = findById(currentId, current);
    } else if (quoteMap[source.droppableId]) {
      current = [...quoteMap[source.droppableId]];
      target = current[source.index];
    }
  }

  if (quoteMap) {
    if (typeof quoteMap === 'object' && quoteMap.length && quoteMap.length > 0) {
      next = getStageByName(destination.droppableId, quoteMap);
    } else if (quoteMap[destination.droppableId]) {
      next = [...quoteMap[destination.droppableId]];
    }
  }

  // moving to same list
  if (source.droppableId === destination.droppableId) {
    const reordered = reorder(
      current,
      source.index,
      destination.index,
    );
    const result = {
      quoteMap,
      [source.droppableId]: reordered,
    };
    return {
      quoteMap: result,
      // not auto focusing in own list
      autoFocusQuoteId: null,
    };
  }

  // moving to different list

  // remove from original
  current.splice(source.index, 1);

  // insert into next
  next.splice(destination.index, 0, target);

  const result = {
    quoteMap,
    [source.droppableId]: current,
    [destination.droppableId]: next,
  };

  return {
    result,
    autoFocusQuoteId: target.id,
  }
};



// WEBPACK FOOTER //
// ./src/utils/dnd.js